import axios from 'axios'
import apiConfig from '../../config/config'

export async function getDBData(token) {
    const config = getConfig(token);
    return axios.get(`${apiConfig.rest}/admin/api/export`, config)
}

export async function exportData(token, dataType) {
    const config = getConfig(token);
    config['timeout'] = 380000;
    return await axios.post(`${apiConfig.rest}/admin/api/export`, {'exportType': dataType}, config)
}

export async function exportFile(token, dataType) {
  const url = `${apiConfig.rest}/admin/api/export`;
  const config = {
    ...getConfig(token),           // z.B. { headers: { Authorization: `Bearer ${token}` } }
    timeout: 380000,
    responseType: 'blob',          // Wichtig für Datei-Download!
    onDownloadProgress: (e) => console.log(e.loaded, e.total)
  };

  const res = await axios.post(url, { 'exportType': dataType }, config);
  return res; // res.data ist Blob, res.headers enthält ggf. Dateiname
}


function getConfig(userToken) {
    const config = {
        headers: {
            Authorization: `Bearer ${userToken}`,
        },
    };

    return config;
}